import ApiFactory from '@/factories/ApiFactory';
import { prepAutocompleteData, serialize } from '@/services/UtilityService';
import { checkHasPermission, POS_EDIT_BUSINESS_MENU_CATEGORY } from '@/middlewares/permissions';

const getBusinessCategoriesByMenuType = (businessId, menuType, filters) => {
	const query = serialize({ status: 1, loadMenuItems: true, ...filters });
	return new Promise((resolve, reject) => {
		const endpoint = `posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_categories?${query}`;
		ApiFactory.get(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const getMenuTypes = (businessId) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`/posweb/v1/businesses/${businessId}/menu_types`).then(({ data }) => {
			resolve(prepAutocompleteData(data.data, 'description', 'code'));
		}, reject);
	});
};

const createMenu = (businessId, menuType, payload) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_categories`;
		ApiFactory.post(endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const updateMenu = (businessId, menuType, payload) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_categories`;
		ApiFactory.put(endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const menuCategoryReorder = (businessId, menuType, categoryId, index) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_categories/${categoryId}/order/${index}`;
		ApiFactory.put(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const menuItemReorder = (businessId, menuType, itemId, index) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_items/${itemId}/order/${index}`;
		ApiFactory.put(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const getMenuItemById = (businessId, menuType, itemId) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_items/${itemId}`;
		ApiFactory.get(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const createMenuItem = (payload, businessId, menuType) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_items`;
		ApiFactory.post(endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const updateMenuItem = (payload, businessId, menuType, itemId) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_items/${itemId}`;
		ApiFactory.put(endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const updateMenuItemStatus = (businessId, menuType, itemId, status) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menuType}/menu_items/${itemId}/active/${status}`;
		ApiFactory.put(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const getStoreTypes = () => {
	return new Promise((resolve, reject) => {
		const endpoint = `/businesses/v1/store_types`;
		ApiFactory.get(endpoint).then(({ data }) => {
			resolve(prepAutocompleteData(data.data, 'value', 'id'));
		}, reject);
	});
};

const createVariantItem = (payload, businessId, itemId, variantId) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_items/${itemId}/variants/${variantId}/items`;
		ApiFactory.post(endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const updateVariantItem = (payload, businessId, itemId, variantId) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_items/${itemId}/variants/${variantId}/items/${payload.id}`;
		ApiFactory.put(endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const deleteVariantItem = (businessId, itemId, variantId, variantItemId) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_items/${itemId}/variants/${variantId}/items/${variantItemId}/active/0`;
		ApiFactory.put(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const deleteProduct = (businessId, menu, productId) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`posweb/v1/businesses/${businessId}/menu_types/${menu}/menu_items/${productId}/active/2`).then(
			resolve,
			reject
		);
	});
};

const deletePendingProduct = (businessId, menu, productId) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/${businessId}/menu_types/${menu}/menu_items/${productId}/pending  `;
		ApiFactory.delete(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const addImage = (id, payload) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/5/menu_items/${id}/images`;
		ApiFactory.post(endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const deleteImage = (menuItemId, imageId) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/posweb/v1/businesses/5/menu_items/${menuItemId}/images/${imageId}`;
		ApiFactory.delete(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const frequencySubmit = (businessId, categoryId, payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(
			`/posweb/v1/businesses/${businessId}/menu_types/DELIVERY/menu_categories/${categoryId}/frequency`,
			payload
		).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const canEditBusinessMenuCategory = () => {
	return checkHasPermission([POS_EDIT_BUSINESS_MENU_CATEGORY]);
};

export default {
	getBusinessCategoriesByMenuType,
	getMenuTypes,
	createMenu,
	updateMenu,
	menuCategoryReorder,
	menuItemReorder,
	getMenuItemById,
	createMenuItem,
	updateMenuItem,
	updateMenuItemStatus,
	getStoreTypes,
	createVariantItem,
	updateVariantItem,
	deleteVariantItem,
	deleteProduct,
	deletePendingProduct,
	addImage,
	deleteImage,
	frequencySubmit,
	canEditBusinessMenuCategory,
};
